/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
export var DISABLED_MODIFIER = "disabled";
export var HOVERED_RANGE_MODIFIER = "hovered-range";
export var OUTSIDE_MODIFIER = "outside";
export var SELECTED_MODIFIER = "selected";
export var SELECTED_RANGE_MODIFIER = "selected-range"; // modifiers the user can't set because they are used by Blueprint or react-day-picker

export var DISALLOWED_MODIFIERS = [DISABLED_MODIFIER, HOVERED_RANGE_MODIFIER, OUTSIDE_MODIFIER, SELECTED_MODIFIER, SELECTED_RANGE_MODIFIER];
export function getDefaultMaxDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear());
  date.setMonth(11
  /* DECEMBER */
  , 31);
  return date;
}
export function getDefaultMinDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 20);
  date.setMonth(0
  /* JANUARY */
  , 1);
  return date;
}
export function combineModifiers(baseModifiers, userModifiers) {
  var modifiers = baseModifiers;

  if (userModifiers != null) {
    modifiers = {};

    for (var _i = 0, _a = Object.keys(userModifiers); _i < _a.length; _i++) {
      var key = _a[_i];

      if (DISALLOWED_MODIFIERS.indexOf(key) === -1) {
        modifiers[key] = userModifiers[key];
      }
    }

    for (var _b = 0, _c = Object.keys(baseModifiers); _b < _c.length; _b++) {
      var key = _c[_b];
      modifiers[key] = baseModifiers[key];
    }
  }

  return modifiers;
}